import React, { Component } from 'react';
import { connect } from 'react-redux';
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Media from "./Media";
import Grid from "./Grid";
import * as ResponseData from './Saga/ResponseData';
import Button from '@material-ui/core/Button';
import CsvButton from "./CsvButton";



interface Props {
    respose_list: any
}




interface State {

}



class CustomerList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);





    }







    render() {
        var kanri = 0;
        var ippan = 0;
        var daitou = 0;
        var daiwa = 0;
        var sekiwa = 0;
        var touken = 0;
        var daikyo = 0;
        var anabuki = 0;
        var sonota = 0;
        var all = 0;
        if (this.props.respose_list.length !== 0) {
            this.props.respose_list.forEach((element: any) => {
                if (element.kanri_corp_no == 1) {
                    kanri = kanri + 1;
                } else if (element.kanri_corp_no == 8) {
                    ippan = ippan + 1;
                } else if (element.kanri_corp_no == 5) {
                    daitou = daitou + 1;
                } else if (element.kanri_corp_no == 4) {
                    daiwa = daiwa + 1;
                } else if (element.kanri_corp_no == 7) {
                    sekiwa = sekiwa + 1;
                } else if (element.kanri_corp_no == 14) {
                    touken = touken + 1;
                } else if (element.kanri_corp_no == 3) {
                    daikyo = daikyo + 1;
                } else if (element.kanri_corp_no == 2) {
                    anabuki = anabuki + 1;
                } else if (element.kanri_corp_no !== null) {
                    sonota = sonota + 1;
                }
            });
            all = kanri + ippan + daitou + daiwa + sekiwa + touken + daikyo + anabuki + sonota;
        }
        return (
            <div>
                <div>
                    <Button style={{ width: 200, fontSize: 15 }} size="large" variant="contained" color="primary">
                        総件数：{this.props.respose_list.length}件
                </Button>
                    <Button style={{ width: 150, marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        管理：{kanri}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#008b8b', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        一般：{ippan}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#dc143c', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        大東：{daitou}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#ffd700', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        大和：{daiwa}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#4169e1', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        積和：{sekiwa}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#66cdaa', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        東建：{touken}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#daa520', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        大京：{daikyo}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#fa8072', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        穴吹HS：{anabuki}件
                </Button>
                    <Button style={{ width: 150, borderColor: '#000000', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        その他：{sonota}件
                </Button>
                </div>
                <div>
                    <Button style={{ width: 200, fontSize: 15 }} size="large" variant="contained" color="primary">
                        物件数：{all}件
                </Button>
                    <Button style={{ width: 150, marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(kanri / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#008b8b', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(ippan / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#dc143c', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(daitou / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#ffd700', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(daiwa / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#4169e1', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(sekiwa / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#66cdaa', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(touken / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#daa520', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(daikyo / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#fa8072', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(anabuki / all * 100)}％
                </Button>
                    <Button style={{ width: 150, borderColor: '#000000', marginLeft: 15, fontSize: 15 }} size="large" variant="outlined" color="primary">
                        {Math.round(sonota / all * 100)}％
                </Button>
                    <CsvButton />
                </div>
            </div>
        );
    }
};


const mapStateToProps = (state: any) => {
    return {

        respose_list: state.ResponseData.respose_list,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




